import * as v from 'valibot';

const getOptionSchema = (message: string) => ({
  id: v.string(message),
  label: v.string(message),
});

export const providerSearchFormSchema = v.object({
  additional: v.pipe(
    v.object({
      companyName: v.optional(v.string('Company Name is required')),
      portPostal: v.optional(v.string('Postal Code is required')),
      scac: v.optional(v.string('SCAC is required')),
    }),
    v.check(
      (input) => Boolean(input.scac || input.companyName || input.portPostal),
      'At least one of Company Name, SCAC, or Port Postal is required',
    ),
  ),
  country: v.object(getOptionSchema('Country is required')),
});

export const providerSearchParamsSchema = v.object({
  limit: v.optional(v.pipe(v.number(), v.minValue(0)), 10),
  page: v.optional(v.pipe(v.number(), v.minValue(1)), 1),
});

export type ProviderSearchFormValues = v.InferOutput<typeof providerSearchFormSchema>;
export type ProviderSearchParams = v.InferOutput<typeof providerSearchParamsSchema>;
